import React from 'react';
import { useSelector } from 'react-redux';
import Favicon from 'react-favicon';

const FaviconWrapper = () => {
  const { favicon } = useSelector((s) => s.eventConfigs);
  return <Favicon url={favicon} />;
};

export default FaviconWrapper;
